let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Meta")).then(() => parcelRequire('40Zwe'));